import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import { IMember, selectRemoveMemberLink } from '@store/members'
import Theme from '@theme'
import { Menu, MenuItem } from '@tribegroup'

interface IProps {
  member: IMember
  onClick: VoidFunction
  showRemoveConfirmation: VoidFunction
}

const InboxMemberPopupMenu: React.FC<IProps> = ({ member, showRemoveConfirmation, onClick }) => {
  const hasRemoveMemberLink = useSelector((state: IApplicationState) =>
    Boolean(selectRemoveMemberLink(state, member.id)),
  )

  return (
    <Menu width={11.75} onClick={onClick}>
      <MenuItem
        selected
        iconColor={Theme.primaryColor}
        disabled
        elementName="menu-item-member-role"
      >
        <FormattedMessage id={`inbox.sidebar.members.${member.role_type}`} />
      </MenuItem>
      {hasRemoveMemberLink && (
        <MenuItem
          destructive
          onClick={showRemoveConfirmation}
          elementName="menu-item-remove-member"
        >
          <FormattedMessage
            id="inbox.sidebar.members.removeMember"
            values={{ name: member.first_name || member.email }}
          />
        </MenuItem>
      )}
    </Menu>
  )
}

export default InboxMemberPopupMenu
